import { render, staticRenderFns } from "./OktellNumberReport.vue?vue&type=template&id=5dfea1fc&"
import script from "./OktellNumberReport.vue?vue&type=script&lang=js&"
export * from "./OktellNumberReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports